import GameDetailsCardMini from "./gameDetailsCardMini.molecule";

export default GameDetailsCardMini;
